import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { PageCard } from '../../components/layout/page/PageCard';
import { JobAttributionListItem } from '../../components/people/JobAttributionListItem';
import { JOB_LEVEL_OPTIONS } from '../../services/collaboratorProfileOptions';
import {
  fetchMyJobAttributions,
  MyJobAttributions,
} from '../../services/myCollaboratorApi';

function jobLevelLabel(value?: string | null): string {
  if (!value) return '';
  return JOB_LEVEL_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export function MyAttributionsSection() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<MyJobAttributions | null>(null);

  useEffect(() => {
    void (async () => {
      setLoading(true);
      try {
        setData(await fetchMyJobAttributions());
      } catch {
        toast.error('Falha ao carregar atribuições do cargo.');
        setData(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <p className="text-secondary-500">Carregando atribuições...</p>;
  }

  const hasJob = Boolean(data?.jobPositionId && data?.jobLevel);
  const level = jobLevelLabel(data?.jobLevel);

  return (
    <PageCard
      title="Atribuições do cargo"
      subtitle={
        hasJob
          ? `${data?.jobPositionName ?? 'Cargo'}${level ? ` · ${level}` : ''} — orientações do cargo. Não são itens avaliáveis.`
          : 'Cargo e nível ainda não foram definidos no seu cadastro.'
      }
    >
      {!hasJob ? (
        <p className="text-sm text-secondary-500">
          Quando a empresa definir seu cargo e nível, as atribuições aparecerão aqui.
        </p>
      ) : !data?.attributions.length ? (
        <p className="text-sm text-secondary-500">
          Nenhuma atribuição cadastrada para o seu cargo e nível.
        </p>
      ) : (
        <ul className="space-y-2">
          {data.attributions.map((item) => (
            <JobAttributionListItem
              key={item.id}
              kindName={item.kindName}
              title={item.title}
              description={item.description}
            />
          ))}
        </ul>
      )}
    </PageCard>
  );
}
